// **********************************************************
// Product slider
// **********************************************************

const productSliderMain = document.querySelectorAll('[data-slider="product-slider-main"]');
const productSliderThumb = document.querySelectorAll('[data-slider="product-slider-thumb"]');


// *******************************************************************************
// 1.1 - Product Thumb Slider
// *******************************************************************************

const productThumbSliderOptions = {
  slidesPerView: 4,
  spaceBetween: 8,
  watchOverflow: true,
  speed: 600,
  observer: true,
};

productSliderThumb.forEach((el) => new Swiper(el, productThumbSliderOptions));

// *******************************************************************************
// 1.2 -Product Main Slider
// *******************************************************************************

const productSliderMainOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 300,
  autoHeight: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  thumbs: {
    swiper: false,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};

productSliderMain.forEach((el, i) => {
  const productSliderMainParent = el.closest('.product-slider');
  const arrowRight = productSliderMainParent.querySelector('.arrow-right');
  const arrowLeft = productSliderMainParent.querySelector('.arrow-left');
  const paginationElement = productSliderMainParent.querySelector('.swiper-pagination');

  productSliderMainOptions.navigation.nextEl = arrowRight;
  productSliderMainOptions.navigation.prevEl = arrowLeft;
  productSliderMainOptions.pagination.el = paginationElement;

  productSliderMainOptions.thumbs.swiper = productSliderThumb[i].swiper;

  // eslint-disable-next-line no-new
  new Swiper(el, productSliderMainOptions);
});

// **********************************************************
// Wishlist popup
// **********************************************************
function closeSliderPopups() {
  const allOpenSliderPopups = document.querySelectorAll('.wishlist-popup.is-open');
  allOpenSliderPopups.forEach((el) => {
    el.classList.remove('is-open');
  });
}

const openSliderPopups = document.querySelectorAll('.product-slider .wishlist-button');
const openSliderComparisonPopups = document.querySelectorAll('.product-slider .compare-button');
if (openSliderPopups) {
  openSliderPopups.forEach((openPopup) => {
    openPopup.addEventListener('click', () => {
      const parent = openPopup.closest('.product-slider');
      const popup = parent.querySelector('.wishlist-popup:not(.comparison-popup)');
      const close = popup.querySelector('.wishlist-popup__close');
      const popupParent = popup.closest('.product-slider__thumb-wrapper');

      if (openPopup.classList.contains('is-active')) {
        closeSliderPopups();
        document.body.appendChild(popup);
        popup.classList.remove('added');
        openPopup.classList.add('disabled');
        popup.classList.add('removed');
        popup.classList.add('is-open');

        setTimeout(() => {
          popup.classList.remove('is-open');
          openPopup.classList.remove('disabled');
          popupParent.appendChild(popup);
        }, 5000);

      } else {
        closeSliderPopups();
        document.body.appendChild(popup);
        popup.classList.remove('removed');
        openPopup.classList.add('disabled');
        popup.classList.add('added');
        popup.classList.add('is-open');

        setTimeout(() => {
          popup.classList.remove('is-open');
          openPopup.classList.remove('disabled');
          popupParent.appendChild(popup);
        }, 5000);
      }

      close.addEventListener('click', () => {
        popup.classList.remove('is-open');
        openPopup.classList.remove('disabled');
        popupParent.appendChild(popup);
      });
    });
  });
}

if (document.querySelector('.product-module') && openSliderComparisonPopups) {
  openSliderComparisonPopups.forEach((openComparisonPopup) => {
    openComparisonPopup.addEventListener('click', (el) => {
      if (el.target.innerHTML !== el.target.dataset.altertext) {
        el.preventDefault();
        let compareCookie = getCookie('wc_compare');
        if (compareCookie) {
          compareCookie = JSON.parse(compareCookie);
          compareCookie.push( el.target.dataset.productid );
        } else {
          compareCookie = [ el.target.dataset.productid ];
        }
        setCookie('wc_compare', JSON.stringify(compareCookie));
        const parent = openComparisonPopup.closest('.product-slider__thumb-wrapper');
        const popup = parent.querySelector('.comparison-popup');

        closePopups();
        document.body.appendChild(popup);
        popup.classList.remove('added');
        popup.classList.add('is-open');
        popup.classList.add('added');

        setTimeout(() => {
          popup.classList.remove('is-open');
          parent.appendChild(popup);
        }, 5000);
      }
      // eslint-disable-next-line no-param-reassign
      el.target.innerHTML = el.target.dataset.altertext;
    });
  });
}
